// Taken from https://lucide.dev/icons/
export const ICONS = {
  menu: 'M4 5h16M4 12h16M4 19h16',
  search: 'M 3 11 A 8 8 0 1 0 19 11 A 8 8 0 1 0 3 11 M 21 21 L 16.66 16.66',
  calendar: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
  eye: 'M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0 M9 12 a3 3 0 1 0 6 0 a3 3 0 1 0 -6 0',
  eyeOff:
    'm2 2 20 20 M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49 M14.084 14.158a3 3 0 0 1-4.242-4.242 M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143',
  circleCheck: 'M12 2a10 10 0 110 20 10 10 0 010-20zM9 12l2 2 4-4',
  circleInfo: 'M12 2a10 10 0 110 20 10 10 0 010-20zm0 14v-4m0-4h.01',
  circleX: 'M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zM15 9l-6 6M9 9l6 6',
  circleExclamation: 'M12 2a10 10 0 110 20 10 10 0 010-20zm0 6v4m0 4h.01',
  circleQuestion: 'M12 2a10 10 0 110 20 10 10 0 010-20zM9.09 9a3 3 0 015.83 1c0 2-3 3-3 3m.08 4h.01',
  circleMinus: 'M12 2a10 10 0 110 20 10 10 0 010-20zM8 12h8',
  circlePlus: 'M12 2a10 10 0 110 20 10 10 0 010-20zM8 12h8m-4-4v8',
  circleUser: 'M18 20a6 6 0 00-12 0m10-10a4 4 0 10-8 0 4 4 0 108 0m6 2a10 10 0 10-20 0 10 10 0 1020 0',
  chevronDown: 'm19.5 8.25-7.5 7.5-7.5-7.5',
  chevronRight: 'M9 18l6-6-6-6',
  chevronLeft: 'M15 18l-6-6 6-6',
  chevronsRight: 'M6 17l5-5-5-5M13 17l5-5-5-5',
  chevronsLeft: 'M11 17l-5-5 5-5M18 17l-5-5 5-5',
  chevronUp: 'm4.5 15.75 7.5-7.5 7.5 7.5',
  arrowLeft: 'M12 19l-7-7 7-7M19 12H5',
  close: 'M18 6L6 18M6 6l12 12',
  user: 'M12 3a5 5 0 110 10 5 5 0 010-10zm8 18a8 8 0 00-16 0',
  asterisk: 'M12 6v12M17.196 9L6.804 15M6.804 9l10.392 6',
  users:
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87M9 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8z',
  video:
    'M16 13l5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5M4 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4z',
  tag: 'M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42zM7.5 7a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z',
  image:
    'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM9 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm12 8-3.086-3.086a2 2 0 0 0-2.828 0L6 21',
  list: 'M3 5h.01 M3 12h.01 M3 19h.01 M8 5h13 M8 12h13 M8 19h13',
  house:
    'M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8 M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  doorOpen:
    'M11 20H2 M11 4.562v16.157a1 1 0 0 0 1.242.97L19 20V5.562a2 2 0 0 0-1.515-1.94l-4-1A2 2 0 0 0 11 4.561z M11 4H8a2 2 0 0 0-2 2v14 M14 12h.01 M22 20h-3',
  trash: 'M10 11v6M14 11v6M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2',
  restore:
    'M3 3h18a1 1 0 011 1v3a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm1 5v11a2 2 0 002 2h2M20 8v11a2 2 0 01-2 2h-2m-7-6l3-3 3 3m-3-3v9',
  pencil:
    'M21.174 6.812a1 1 0 00-3.986-3.987L3.842 16.174a2 2 0 00-.5.83l-1.321 4.352a.5.5 0 00.623.622l4.353-1.32a2 2 0 00.83-.497zM15 5l4 4'
};
